module.exports = __webpack_public_path__ + "static/img/GE.81deeebc.svg";